import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { MainService } from '../main.service';
import { SecurityService } from '../security.service';

@Component({
  selector: 'lib-multi-account',
  templateUrl: './multi-account.component.html',
  styleUrls: ['./multi-account.component.css']
})
export class MultiAccountComponent implements OnInit {
  b_acct_id: any

  constructor(
    public mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    public Security:SecurityService
  ) {
  }

  ngOnInit(): void {
  }
  async SubmitAccountfinal() {
    this.Security.b_acct_id = this.b_acct_id
    await this.Security.SubmitAccount()
  }
  async changeaccountprev(b_acct_id: any) {
    this.Security.changeaccount(b_acct_id)
  }
  goback() {
 
      this.router.navigate(['./login' ]);
   

    


  }


}
